import { getHexcolorForAutomaticColorScheme } from 'owa-calendar-sharing/lib/utils/colorWrapper';
import owaCalendarStrings from 'owa-strings/owa-calendar-strings';
var assign = require('object-assign');
/**
 * Utility function to parse calendar folders and calendar groups
 * @returns state of type SharedCalendarsOptionViewState
 */
export default function parseCalendarFoldersResponse(calendarFoldersResponse) {
    var folderIdList = [];
    var folderIdCalendarViewStateMap = {};
    var initialNotificationState = {};
    var calendarGroups = calendarFoldersResponse.CalendarGroups;
    for (var i = 0; i < calendarGroups.length; i++) {
        var calendars_1 = calendarGroups[i].Calendars;
        for (var j = 0; j < calendars_1.length; j++) {
            var calendarEntry = calendars_1[j];
            if (!calendarEntry.CalendarFolderId) {
                continue;
            }
            var folderId = calendarEntry.CalendarFolderId.Id;
            folderIdList.push(folderId);
            folderIdCalendarViewStateMap[folderId] = {
                folderId: folderId,
                calendarName: getCalendarDisplayName(calendarEntry),
                hexColorString: getHexcolorForAutomaticColorScheme(calendarEntry.HexColorString),
                canShare: calendarEntry.CanShare,
                canEnableChangeNotifications: false,
            };
        }
    }
    var calendarFolders = calendarFoldersResponse.CalendarFolders;
    for (var i = 0; i < calendarFolders.length; i++) {
        var calendarFolder = calendarFolders[i];
        var folderId = calendarFolder.FolderId.Id;
        if (calendarFolder.CanEnableChangeNotifications) {
            folderIdCalendarViewStateMap[folderId].canEnableChangeNotifications = true;
            initialNotificationState[folderId] = calendarFolder.ChangeNotificationStatus;
        }
    }
    var calendars = [];
    for (var i = 0; i < folderIdList.length; i++) {
        calendars.push(folderIdCalendarViewStateMap[folderIdList[i]]);
    }
    return {
        calendars: calendars,
        //Creating new objects to prevent mutating the same object for both initial and current state.
        initialState: assign({}, initialNotificationState),
        currentState: assign({}, initialNotificationState),
    };
}
function getCalendarDisplayName(calendarEntry) {
    return calendarEntry.CalendarFolderType == 1 /* DefaultCalendar */
        ? owaCalendarStrings.calendarText
        : calendarEntry.CalendarName;
}
//# sourceMappingURL=parseCalendarFoldersResponse.js.map